/** Brief 12, Kapitan - Avtomatizatsiya, in Russian. */
export const ruB12Automation = {
  "auto.tabs.label": "Разделы автоматизации",
  "auto.tab.rules": "Автоматизации",
  "auto.tab.campaigns": "Кампании",
  "auto.rules.new": "+ Новое правило",
  "auto.rules.list": "Правила автоматизации",
  "auto.rules.denied": "Автоматизацией управляет только владелец.",
  "auto.rules.empty.title": "Правил пока нет",
  "auto.rules.empty.message": "Создайте первое правило: когда, при каком условии и что сделать.",
  "auto.rules.error": "Не удалось загрузить правила.",
  "auto.retry": "Повторить",
  "auto.kind.ai": "AI-триггер",
  "auto.kind.rule": "Правило",
  "auto.rule.toggle": "{name}: включить",
  "auto.rule.on": "Правило включено",
  "auto.rule.off": "Правило выключено",
  "auto.rule.toggleError": "Не удалось сохранить правило",
  "auto.rule.never": "Ещё не срабатывало",
  "auto.rule.last": "Последний раз: {when}",
  "auto.rule.lastWeek": "Последний раз: {when} · {count} раз / неделя",
  "auto.when.today": "сегодня {time}",
  "auto.when.yesterday": "вчера {time}",
  "auto.part.hours": "{count} ч",
  "auto.part.days": "{count} дн",
  "auto.part.frozen": "сделка заморожена",
  "auto.part.tags": "тег: {tags}",
  "auto.trigger.stage_reached": "Сделка дошла до этапа",
  "auto.trigger.trip_ended": "После поездки",
  "auto.trigger.payment_approved": "Платёж подтверждён",
  "auto.trigger.proposal_opened": "Открыта страница предложения",
  "auto.trigger.birthday": "День рождения",
  "auto.trigger.no_reply": "Не ответил",
  "auto.trigger.offer_silent": "Предложение отправлено, ответа нет",
  "auto.action.send_template": "AI отправит сообщение",
  "auto.action.create_task": "Создать задачу",
  "auto.action.notify": "Уведомить ответственного",
  "auto.trigger.stage_silent": "Сделка стоит на этапе",
  "auto.trigger.operator_silent": "Оператор не ответил",
  "auto.action.remind_operator": "Напомнить оператору",
  "auto.outcome.won": "Выигранная сделка",
  "auto.outcome.lost": "Проигранная сделка",
  "auto.outcome.booked": "Забронированная сделка",
  "auto.form.title": "Новое правило",
  "auto.form.name": "Название",
  "auto.form.event": "Событие",
  "auto.form.condition": "Условие",
  "auto.form.action": "Действие",
  "auto.form.always": "Всегда",
  "auto.form.frozen": "Сделка заморожена",
  "auto.form.byTag": "По тегу",
  "auto.form.tags": "Теги (через запятую)",
  "auto.form.outcome": "Итог",
  "auto.form.hours": "Если не ответил, часов",
  "auto.form.days": "После окончания поездки, дней",
  "auto.form.template": "Шаблон",
  "auto.form.taskTitle": "Заголовок",
  "auto.form.body": "Текст",
  "auto.form.choose": "Выберите",
  "auto.form.preview": "КОГДА «{event}» → ЕСЛИ «{condition}» → «{action}»",
  "auto.form.note": "Правило сохраняется выключенным. Включите его в списке.",
  "auto.form.cancel": "Отмена",
  "auto.form.save": "Сохранить",
  "auto.form.saved": "Правило сохранено",
  "auto.form.saveError": "Не удалось сохранить правило",
  "auto.form.optionsError": "Не удалось загрузить варианты правила.",
  "auto.runs.title": "Запуски: {name}",
  "auto.runs.empty": "Это правило ещё не запускалось.",
  "auto.runs.error": "Не удалось загрузить запуски.",
  "auto.runs.when": "Дата",
  "auto.runs.subject": "Объект",
  "auto.runs.status": "Статус",
  "auto.runs.reason": "Причина",
  "auto.run.sent": "Выполнено",
  "auto.run.skipped": "Пропущено",
  "auto.run.failed": "Ошибка",
  "camp.new": "+ Кампания",
  "camp.denied": "Кампании отправляют менеджер и владелец.",
  "camp.empty.title": "Кампаний пока нет",
  "camp.empty.message": "Создайте первую кампанию: кому, по какому каналу и когда.",
  "camp.error": "Не удалось загрузить кампании.",
  "camp.status.scheduled": "Запланирована",
  "camp.status.draft": "Черновик",
  "camp.status.sending": "Идёт",
  "camp.status.sent": "Завершена",
  "camp.status.paused": "На паузе",
  "camp.status.cancelled": "Отменена",
  "camp.channel.telegram": "Telegram",
  "camp.channel.instagram": "Instagram Direct",
  "camp.channel.any": "Любой канал",
  "camp.meta.people": "{count} клиентов",
  "camp.meta.perDay": "{count} в день",
  "camp.bar.sent": "Отправлено",
  "camp.bar.read": "Прочитано",
  "camp.bar.replied": "Ответили",
  "camp.form.title": "Новая кампания",
  "camp.form.name": "Название",
  "camp.form.segment": "Сегмент",
  "camp.form.destination": "Направление",
  "camp.form.lastTrip": "Последняя поездка",
  "camp.form.branch": "Филиал",
  "camp.form.all": "Все",
  "camp.form.trip6m": "Более 6 месяцев",
  "camp.form.trip1y": "Более 1 года",
  "camp.form.audience": "Подходят: {count} · в Telegram {telegram} · только с согласием",
  "camp.form.audienceLoading": "Считаем клиентов",
  "camp.form.channel": "Канал",
  "camp.form.template": "Шаблон",
  "camp.form.noTemplate": "Без шаблона",
  "camp.form.schedule": "Расписание",
  "camp.form.limit": "Дневной лимит",
  "camp.form.text": "Текст",
  "camp.form.warnOver": "Лимит Telegram жёсткий: больше {limit} сообщений в день от агентства ведут к блокировке. Лимит снижается до {limit}.",
  "camp.form.warnTelegram": "Лимит Telegram жёсткий · {limit} в день, закончится за {days} дн. В Instagram массовое сообщение по правилам Meta только тем, кто писал в последние 24 часа.",
  "camp.form.warnInstagram": "Instagram: отправляется только тем, кто писал в последние 24 часа (правило Meta).",
  "camp.form.previewEmpty": "Здесь появится текст сообщения.",
  "camp.form.cancel": "Отмена",
  "camp.form.schedulePress": "Запланировать",
  "camp.form.saved": "Кампания запланирована",
  "camp.form.draftSaved": "Кампания сохранена как черновик",
  "camp.form.saveError": "Не удалось сохранить кампанию",
  "camp.detail.results": "Результаты",
  "camp.detail.previewError": "Не удалось посчитать получателей.",
  "camp.detail.recipients": "Получатели",
  "camp.detail.client": "Клиент",
  "camp.detail.state": "Статус",
  "camp.detail.willSend": "Будет отправлено: {count} клиентам",
  "camp.detail.send": "Отправить",
  "camp.detail.confirm": "Отправить?",
  "camp.detail.cancel": "Отмена",
  "camp.detail.stop": "Остановить кампанию",
  "camp.detail.stopped": "Кампания остановлена",
  "camp.detail.stopError": "Не удалось остановить кампанию",
  "camp.detail.queued": "Кампания поставлена в очередь",
  "camp.detail.sendError": "Не удалось отправить кампанию",
  "camp.recipient.queued": "В очереди",
  "camp.recipient.skipped_no_consent": "Нет согласия на рассылку",
  "camp.recipient.skipped_no_channel": "Нет переписки",
  "camp.recipient.skipped_not_allowed": "AI выключен или клиент заблокирован",
} as const;
